import React, { useEffect, useState } from 'react';
import { nwsAlertService } from '../services/api';
import { NwsAlert } from '../types';

function formatPopulation(value: number | null) {
  if (value === null || value <= 0) return null;
  return `Estimated population: ${value.toLocaleString()}`;
}

const NwsAlertsPanel: React.FC = () => {
  const [alerts, setAlerts] = useState<NwsAlert[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    nwsAlertService.listActive()
      .then((response) => setAlerts(response.data.alerts))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="page-section">
      <div className="section-heading-row">
        <div>
          <p className="eyebrow">Live feed</p>
          <h3 className="section-heading">NWS active alerts</h3>
        </div>
        <span className="module-status module-status-live">Great Lakes</span>
      </div>
      {loading && <div className="module-note">Loading active alerts...</div>}
      {error && <div className="alert alert-error">The NWS alert feed is temporarily unavailable.</div>}
      {!loading && !error && alerts.length === 0 && <div className="module-note">No active severe alerts in the Great Lakes region.</div>}
      {!loading && !error && alerts.length > 0 && (
        <div className="discussion-stack">
          {alerts.slice(0, 8).map((alert) => (
            <article className="module-card" key={alert.id}>
              <div className="module-header">
                <div>
                  <p className="eyebrow">{alert.hazard} | {alert.severity}</p>
                  <h4 className="section-heading">{alert.event}</h4>
                </div>
                <span className="module-status module-status-limited">{alert.urgency}</span>
              </div>
              <p className="page-copy">{alert.area_description}</p>
              <p className="field-help">
                {formatPopulation(alert.estimated_population) ? `${formatPopulation(alert.estimated_population)} | ` : ''}
                Expires {alert.expires ? new Date(alert.expires).toLocaleString() : 'unknown'}
              </p>
            </article>
          ))}
        </div>
      )}
    </section>
  );
};

export default NwsAlertsPanel;